<ng-container *ngIf="input">
  <div class="row px-0 mx-0 justify-content-between">
    <input type="text"
           [id]="input.MainElementList[0].ID"
           class="col form-control q-bo-input q-bo-wrap"
           [disabled]="input.MainElementList[0].Disabled"
           [required]="input.MainElementList[0].Required"
           [ngClass]="setClass(input)"
           [(ngModel)]="input.MainElementList[0].Value" />
    <button *ngIf="input.MainElementList.length > 1 && input.MainElementList[1].Type === 'BUTTON'"
            style="box-shadow: none !important;"
            class="ml-1 rounded btn q-bo-inputbtn q-bo-wrap"
            (click)="OpenModal(ModalGoCardless);"
            [id]="input.MainElementList[1].ID"
            [title]="input.MainElementList[1].ToolTip">
      <i [ngClass]="[loading ? 'fas fa-spinner fa-pulse' : 'fas fa-file-invoice-dollar']"></i>
    </button>
  </div>
</ng-container>
<!-- Modal grid chapitres elearning-->

<ng-template #ModalGoCardless let-modalGoCardless>
  <div class="modal-header">
    <h1 class="col q-c-main">Mandat</h1>
    <button type="button" class="close" aria-label="Close" (click)="modalGoCardless.close('CANCEL')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style=" max-height: calc(100dvh - 112px); overflow: auto;">
    <ng-container *ngIf="!newModel">
      <p>Envoyer le modèle de mail....</p>
      <button (click)="newModel = true" class="q-btn q-main">Créer un nouveau modèle de mail</button>
      <button (click)="copyToClipboard(urlForm)" class="q-btn q-main"><i class="fas fa-copy mr-1"></i>Copier le lien vers le formulaire</button>
    </ng-container>
    <button *ngIf="newModel" (click)="newModel = false" class="q-btn q-c-danger">Annuler</button>
    <p>
      <q-sendmail *ngIf="!newModel && mailModel" Type="MandatGoCardless" [model]="mailModel" [Ident]="model.IdDonneeFils"></q-sendmail>
      <q-ModelEmail *ngIf="newModel" [ListBo]="listeBo" GroupeModelMail="MandatGoCardless" (save)="OnModelMailSaved($event);"></q-ModelEmail>
    </p>
  </div>
</ng-template>
